import { constantSumNone } from './actions';
import { connect } from 'react-redux';
import Checkbox from '../../common/Checkbox';
import { questionKey } from '../response/reducer';

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  return {
    checked: question.none,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: e =>
    dispatch(constantSumNone(e.target.checked, ownProps.questionId)),
});

const NoneCheckbox = connect(mapStateToProps, mapDispatchToProps)(Checkbox);

export default NoneCheckbox;
